/**
 * timelineSync.js — E2 · TIMELINE_SERVER_SYNC
 *
 * El timeline pasa a vivir en el servidor; localStorage queda como respaldo
 * y NUNCA se borra. Reglas:
 *  - Al abrir: servidor primero. Si el servidor no tiene nada y localStorage
 *    sí, se sube (migración idempotente). Si el servidor falla, se trabaja
 *    offline con localStorage, sin errores para el usuario.
 *  - Al editar: debounce ~1 s y estado "Guardando…" / "Guardado".
 *  - Conflicto (409): misma regla que E1 — recarga silenciosa si no hay
 *    cambios locales, aviso si los hay.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TIMELINE_SERVER_SYNC =
  process.env.REACT_APP_TIMELINE_SERVER_SYNC !== 'false';

export const SAVE_DEBOUNCE_MS = 1000;

const url = (projectId, suffix = '') =>
  `${API}/projects/${projectId}/timeline${suffix}`;

/** Lee el timeline del servidor. `null` = no tiene; lanza si falla la red. */
export const fetchTimeline = async (projectId) => {
  const { data } = await axios.get(url(projectId));
  return data.exists ? { data: data.data, version: data.version } : null;
};

export const putTimeline = async (projectId, doc, baseVersion) => {
  const body = { data: doc };
  if (baseVersion != null) body.base_version = baseVersion;
  const { data } = await axios.put(url(projectId), body);
  return data;
};

/** Sube el snapshot de localStorage. Idempotente del lado del servidor. */
export const migrateTimeline = async (projectId, doc) => {
  const { data } = await axios.post(url(projectId, '/migrate'), { data: doc });
  return data;
};

export const fetchTracks = async (projectId) => {
  const { data } = await axios.get(url(projectId, '/tracks'));
  return data.tracks;
};

export const moveClipOnServer = async (projectId, clipId, { track, start, baseVersion }) => {
  const body = {};
  if (track) body.track = track;
  if (start != null) body.start = start;
  if (baseVersion != null) body.base_version = baseVersion;
  const { data } = await axios.patch(url(projectId, `/clips/${clipId}`), body);
  return data;
};

export const isConflict = (error) => error?.response?.status === 409;

export const serverVersionFrom = (error) =>
  error?.response?.data?.detail?.server_version ?? null;
